import React, { useEffect } from "react";
import SelectValue from "../Selector/SelectValue";
import { DatePicker, Table, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import {
  getListQuestionById,
  getReportQuestionsSurvey,
  getReportSurveyByCard,
  getReportSurveyOverView,
} from "../../../services/slice/SurveySlice";
import { useSelector } from "react-redux";
import { surveySelector } from "../../../services/selector/index.";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import PiceChart from "../Chart/PiceChart";
import { useMemo } from "react";
import { useState } from "react";
import InputSearchBox from "../Input/InputSearchBox";
import BaseButton from "../Button/BaseButton";
import "../../../assets/style/pageStyle/surverManager.scss";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import { IconNext, IconPre } from "../../../assets/icon";

const TabQuestionSurvey = ({ config }) => {
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const { listQuestionById, dataDetailQuestion } = surveyState;
  const [defaultQuestion, setDefaultQuestion] = useState("");
  const [page, setPage] = useState(0);
  const [questionSelect, setQuestionSelect] = useState("");
  const [confiRequest, setConfigRequest] = useState({
    id: 30,
    questionName: questionSelect,
    card: "",
    typeSurvey: 1,
    timeStart: "2023-10-02 10:28:53",
    timeEnd: "2023-10-02 10:28:53",
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  });
  useEffect(() => {
    dispatch(getListQuestionById(config.id));
  }, [config.id]);
  useEffect(() => {
    if (questionSelect) dispatch(getReportQuestionsSurvey(confiRequest));
  }, [defaultQuestion, confiRequest, questionSelect, dispatch]);
  //   useEffect(() => {
  //     dispatch(
  //       getReportSurveyOverView({
  //         id: Number(config?.id),
  //         typeSurvey: Number(config?.typeSurvey),
  //         typeTime: Number(config?.typeTime),
  //         timeStart: config?.timeStart,
  //         timeEnd: config?.timeEnd,
  //       })
  //     );
  //   }, [config]);
  const options = useMemo(() => {
    const result = [];
    listQuestionById?.map((item, index) => {
      result.push({
        value: item,
        label: `Câu ${index + 1}: ${item}`,
      });
    });
    setQuestionSelect(result[0]?.value);
    setConfigRequest({ ...confiRequest, questionName: result[0]?.value });
    return result;
  }, [listQuestionById]);
  const dataSource = useMemo(() => {
    const result = dataDetailQuestion?.data?.map((item, index) => {
      return {
        ...item,
        timeAnswer: item?.timeAnswer,
        STT:
          dataDetailQuestion.total > 10 && page >= 2
            ? (page - 1) * 10 + index + 1
            : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [dataDetailQuestion]);
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="Mã khách hàng" />,
      dataIndex: "card",
      key: "card",
      className: "title  centerCell",
      width: 300,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Thời gian phản hồi" />,
      dataIndex: "timeAnswer",
      key: "timeAnswer",
      className: "title  centerCell",
      width: 300,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: (
        <div className="statusProduct" style={{ minWidth: 100 }}>
          <TranslateText text="Câu trả lời" />
        </div>
      ),
      dataIndex: "answer",
      key: "answer",
      className: "title",
    },
  ];
  return (
    <div className="wrapperQuestionSurvey">
      <div className="headerQuestionSurvey">
        <div className="selectQuestion">
          <span style={{ marginRight: "2.8rem", fontSize: "1.8rem" }}>
            Câu hỏi
          </span>
          <SelectValue
            defaultValue={options ? options[0]?.label : null}
            type={"selectGray flex-1"}
            optionsValue={options ? options : []}
            style={{ flexGrow: "1" }}
            placeholder={"Chọn câu hỏi"}
            handleChange={(value) => setQuestionSelect(value)}
          />
        </div>
        <div className="searchBox">
          <span style={{ marginRight: "1.4rem", fontSize: "1.8rem" }}>
            Mã khách hàng
          </span>
          <InputSearchBox
            setText={(value) =>
              setConfigRequest({ ...confiRequest, card: value })
            }
            width={"320px"}
            placeholder={"Nhập mã khách hàng để tra cứu"}
            optionsValue={options}
          />
        </div>
        <BaseButton
          typeBtn={"btnOrange"}
          className={"bottom-0"}
          content={"Xuất excel"}
        />
      </div>
      <p style={{ marginTop: "19px", fontSize: "18px", fontWeight: "500" }}>
        Tổng số câu trả lời: {dataDetailQuestion?.total}
      </p>
      <Table
        // rowClassName={rowClassName}
        //   loading={tableLoading}
        className="wrapperTblSurvey"
        style={{ width: "100%", marginTop: "2.6rem" }}
        columns={columns}
        dataSource={dataSource}
        pagination={
          dataDetailQuestion?.total > 10
            ? {
                onChange: (value) => {
                  setPage(value);
                },

                pageSize: 10,
                // current: configStatistics.option.offset,
                prevIcon: <IconPre />,
                nextIcon: <IconNext />,
                showSizeChanger: false,
              }
            : false
        }
      />
    </div>
  );
};

export default TabQuestionSurvey;
